import { render, staticRenderFns } from "./EndpointStatisticsList.vue?vue&type=template&id=0dd591cc&"
import script from "./EndpointStatisticsList.vue?vue&type=script&lang=js&"
export * from "./EndpointStatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./EndpointStatisticsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports